import { palette } from '@livable/saas-react-components';
const MuiOutlinedInput = {
  styleOverrides: {
    root: {
      padding: '0',
      fontSize: '18px',
      paddingRight: '0',
      lineHeight: '24px',
      backgroundColor: palette.shades[100],
      transition: "border-color ".concat(palette.transitions.short),
      '&:hover': {
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: palette.shades[700]
        },
        '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
          borderColor: palette.shades[400]
        }
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.primary.main
      },
      '&.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderWidth: '2px'
      },
      '&.Mui-error&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.error.main
      },
      '&.Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.error.main
      },
      '&.Mui-disabled': {
        backgroundColor: palette.shades[200],
        input: {
          textFillColor: palette.shades[600]
        },
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: palette.shades[500]
        }
      },
      '&.MuiInputBase-adornedStart': {
        paddingLeft: '12px'
      }
    },
    input: {
      padding: '12px',
      height: 'initial',
      '&.MuiInputBase-inputAdornedStart': {
        paddingLeft: '0'
      },
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        appearance: 'none',
        margin: 0
      },
      '&[type=number]': {
        appearance: 'textfield'
      }
    },
    inputSizeSmall: {
      padding: '6px 12px',
      height: 'initial'
    },
    notchedOutline: {
      padding: '0 5px',
      borderColor: palette.shades[500],
      transition: "border-color ".concat(palette.transitions.short)
    }
  }
};
export default MuiOutlinedInput;